import { UserCollection } from 'types/generated/graphql';

export const isUserCollection = (item: unknown): item is UserCollection => {
    return (
        typeof item === 'object' &&
        !!item &&
        (item as UserCollection)?.__typename === 'UserCollection'
    );
};
